import * as types from "../constants/courses";
import images from "../../Constant/images";

const INITIAL_STATE = {
  isLoading: false,
  success: false,
  error: null,
 
};

export default function coursesReducer(state = INITIAL_STATE, action) {
  const newState = JSON.parse(JSON.stringify(state));
  
  switch (action.type) {
   
    default:
      return state;
  }
}
